import to from 'await-to-js'
import { setAlertBox } from './snackbar'
import Fetch from '@App/helpers/fetch'
import {
  MESSAGE_ERROR,
  MESSAGE_SUCCESS,
  ALERT_COLORS,
  ALERT_DELAY,
} from '@App/constantes'
import { API_URL } from '@App/configs/rest'

const fetchRegeneratePassword = new Fetch()

export const getRegeneratePassword = (body: any) => {
  return async (dispatch: any) => {
    const [err, data] = await to(fetchRegeneratePassword.put({
      body,
      url: `${API_URL}/users/auth/change-password`,
      headers: {
        'content-type': 'application/json',
      },
    }))

    if (!err) {
      dispatch(setAlertBox({
        title: data && data.message || MESSAGE_SUCCESS,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }))

      return data
    }

    if (err) {
      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))

      return err
    }
  }
}
